export const shouldResendExceptions = [
  'UserNotConfirmedException',
  // 'NotAuthorizedException'
];

export const temporaryPasswordExpired = 'temporary-password-expired';
export const userNotConfirmed = 'user-not-confirmed';
